import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Standings.css'
import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
//import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import logo from '../../images/nsbhl_logo.PNG'

const Standings = () => {
	console.log('inside Standings')
	//const { sendRequest, clearError } = useHttpClient()
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedStandings, setLoadedStandings] = useState()
	const [loadedStandingsArray, setLoadedStandingsArray] = useState([])
	const [leagueName, setLeagueName] = useState()
	const [divisionName, setDivisionName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [masterArray, setMasterArray] = useState()
	//const [returnArray, setReturnArray] = useState([])

	const leagueId = useParams().leagueId

	const getGamesPlayed = (team) => {
		return (
			Number(team.wins || 0) +
			Number(team.losses || 0) +
			Number(team.ties || 0) +
			Number(team.shootoutLosses || 0) +
			Number(team.overtimeLosses || 0)
		)
	}

	const getPointsPercentage = (team) => {
		const gamesPlayed = getGamesPlayed(team)

		if (gamesPlayed === 0) {
			return ''
		}

		const percentage =
			(Number(team.wins || 0) + Number(team.ties || 0) * 0.5) / gamesPlayed

		return percentage.toFixed(3)
	}

	//call to getStandings in the league-controller
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/leagues/${leagueId}/standings`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setDivisionName(responseData.listOfTeams?.[0]?.divisionName || '')

				/* if (responseData.listOfTeams[0].divisionName) {
					setDivisionName(responseData.listOfTeams[0].divisionName)
				} else {
					setDivisionName('')
				} */

				setMasterArray(responseData.masterMasterArray)
				setLoadedStandings(responseData.listOfTeams)
				setLoadedStandingsArray(responseData.listOfTeamsArray)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId, leagueName, year])

	let numberOfTeams
	numberOfTeams = loadedStandings && loadedStandings.length
	console.log('numberOfTeams: ' + numberOfTeams)

	//So, when masterArray comes to us from the backend, it can be a pretty long list
	//if there were many sets of two teams tied for points.  For example, if there were
	//four sets of two teams tied in points, this masterarray would be four times the
	//size we need.  However, the last of those four would be the correct version.
	//So, we reverse the long incoming array, then cut it (splice it) at however many
	//number of teams there are, then we reverse it again.
	masterArray && masterArray.reverse()
	masterArray && masterArray.splice(numberOfTeams)
	masterArray && masterArray.reverse()
	masterArray && console.log(masterArray)

	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	return (
		<React.Fragment>
			<StatsAndStandingsHome />
			<StatsAndStandingsHomeNavigation leagueId={leagueId} />
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && masterArray && (
				<div className='Roster standingsRoster'>
					<div className='standingsMobileLogoWrapper'>
						<img
							src={logo}
							alt='National Scholastic Ball Hockey League'
							className='standingsMobileLogo'
						/>
					</div>

					<h1 className='standingsMainTitle'>League Standings</h1>

					<div className='standingsMobileAccent'></div>

					<h1 className='standingsLeagueTitle'>
						{leagueName}
						{divisionName && ` - ${divisionName} Division`}
					</h1>

					<h2 className='standingsSeason'>
						{session} {year}
					</h2>

					<p className='standingsInstructions'>
						(Click on a team to go to their roster and schedule page)
					</p>

					<div className='standingsTableScroll'>
						<table id='roster' cellSpacing='0' cellPadding='0'>
							<thead>
								<tr>
									<th>Team</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>OTL</th>
									<th>SOL</th>
									<th>T</th>
									<th>GF</th>
									<th>GA</th>
									<th>GD</th>
									<th>Pts</th>
									<th className='standingsPercentageColumn'>%</th>
								</tr>
							</thead>

							<tbody>
								{masterArray.map((team, key) => {
									return (
										<tr key={team._id || key}>
											<td className='tableDataTeamName'>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
													}}
													to={`${session}/${year}/${team.teamName}`}
												>
													{team.teamName}
												</Link>
											</td>

											<td>{getGamesPlayed(team)}</td>
											<td>{Number(team.wins || 0)}</td>
											<td>{Number(team.losses || 0)}</td>
											<td>{Number(team.overtimeLosses || 0)}</td>
											<td>{Number(team.shootoutLosses || 0)}</td>
											<td>{Number(team.ties || 0)}</td>
											<td>{Number(team.goalsFor || 0)}</td>
											<td>{Number(team.goalsAgainst || 0)}</td>

											<td>
												{Number(team.goalsFor || 0) -
													Number(team.goalsAgainst || 0)}
											</td>

											<td>{Number(team.points || 0)}</td>
											<td className='standingsPercentageColumn'>
												{getPointsPercentage(team)}
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>

					<div className='standingsLegend'>
						<span>GP = Games Played</span>
						<span>W = Wins</span>
						<span>L = Losses</span>
						<span>T = Ties</span>
						<span>OTL = Overtime Losses</span>
						<span>SOL = Shootout Losses</span>
						<span>GF = Goals For</span>
						<span>GA = Goals Against</span>
						<span>GD = Goal Differential</span>
						<span>Pts = Standings Points</span>
						{/* <span>% = Points Percentage</span> */}
					</div>
				</div>
			)}
			{/* {!isLoading && masterArray && (
				<div className='Roster'>
					<h1>League Standings</h1>
					<h1>
						{leagueName} {divisionName && ' - ' + divisionName + ' Division'}
					</h1>
					<h2>
						{session} {year}
					</h2>
					<p style={{ textAlign: 'center' }}>
						(Click on a team to go to their roster and schedule page)
					</p>
					<table id='roster' cellSpacing={'0'} cellPadding={'0'}>
						<thead>
							<tr>
								<th>Team</th>
								<th>GP</th>
								<th>W</th>
								<th>L</th>
								<th>T</th>
								<th>GF</th>
								<th>GA</th>
								<th>GD</th>
								<th>Points</th>
								<th>%</th>
							</tr>
						</thead>
						<tbody>
							{masterArray.map((team, key) => {
								{
								}
								return (
									<tr key={key}>
										<td className='tableDataTeamName'>
											<Link
												style={{
													textDecoration: 'none',
													// color: 'black',
													fontWeight: 600,
												}}
												to={`${session}/${year}/${team.teamName}`}
											>
												{team.teamName}
											</Link>
										</td>
										<td>
											{team.wins +
												team.losses +
												team.ties +
												team.shootoutLosses +
												team.overtimeLosses}
										</td>
										<td>{team.wins}</td>
										<td>{team.losses}</td>
										<td>{team.ties}</td>
										<td>{team.goalsFor}</td>
										<td>{team.goalsAgainst}</td>
										<td>{team.goalsFor - team.goalsAgainst}</td>
										<td>{team.points}</td>
										<td>
											{Number(
												(team.wins + team.ties * 0.5) /
													(team.wins +
														team.losses +
														team.overtimeLosses +
														team.shootoutLosses +
														team.ties),
											).toFixed(3)}
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			)} */}
			{!isLoading && !masterArray && (
				<div className='Standings'>
					<h1>
						{leagueName} {divisionName && divisionName} - League Standings
					</h1>
					<h2>
						{session} {year}
					</h2>
					<table id='players' cellSpacing={'0'} cellPadding={'0'}>
						<thead>
							<tr>
								<th>Team</th>
								<th>GP</th>
								<th>W</th>
								<th>L</th>
								<th>T</th>
								{/* <th>OTL</th>
								<th>SOL</th> */}
								<th>GF</th>
								<th>GA</th>
								<th>Pts</th>
							</tr>
						</thead>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default Standings
